import React from 'react';
import PropTypes from 'prop-types';
import { usePermissions, useMenu } from '@/context';

const ProtectedElement = ({
  children,
  requiredRights = [],
  requiredProfile = null,
  requiredRouteAccess = null,
  fallback = null,
  showFallback = true,
  ...props
}) => {
  const {
    hasRight,
    hasAnyRight,
    hasProfile
  } = usePermissions();
  const {
    hasRouteAccess
  } = useMenu(); // Verificar perfil específico se necessário

  if (requiredProfile && !hasProfile(requiredProfile)) {
    return showFallback ? fallback : null;
  } // Verificar direitos específicos se necessário


  if (requiredRights.length > 0) {
    const hasRequiredRights = requiredRights.length === 1 ? hasRight(requiredRights[0]) : hasAnyRight(requiredRights);

    if (!hasRequiredRights) {
      return showFallback ? fallback : null;
    }
  } // Verificar acesso à rota específica se necessário


  if (requiredRouteAccess && !hasRouteAccess(requiredRouteAccess)) {
    return showFallback ? fallback : null;
  } // Se passou por todas as verificações, renderiza o children


  return React.cloneElement(children, props);
};

ProtectedElement.propTypes = {
  children: PropTypes.element.isRequired,
  requiredRights: PropTypes.arrayOf(PropTypes.string),
  requiredProfile: PropTypes.string,
  requiredRouteAccess: PropTypes.string,
  fallback: PropTypes.node,
  showFallback: PropTypes.bool
};
ProtectedElement.defaultProps = {
  requiredRights: [],
  requiredProfile: null,
  requiredRouteAccess: null,
  fallback: null,
  showFallback: true
};
export default ProtectedElement;

